// Admin auth token persistence. The server guards /admin/* with HTTP
// Basic Auth; instead of relying on the browser's native popup (which
// browsers drop between sessions, forcing a re-login every visit) we
// store the base64(user:pass) credential in localStorage and attach it
// as an Authorization header on every API call. Persists until the user
// logs out or a 401 invalidates it.
const STORAGE_KEY = "elvis_admin_auth";

export function getAuthToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

// Store base64("user:pass"). btoa handles the ASCII credential fine.
export function setAuth(user: string, pass: string): void {
  const token = btoa(`${user}:${pass}`);
  localStorage.setItem(STORAGE_KEY, token);
}

export function clearAuth(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isAuthed(): boolean {
  return getAuthToken() != null;
}
